module.exports = __webpack_public_path__ + "static/media/Celeste.90b42250.png";